module.exports = __webpack_public_path__ + "img/download-nor.d7ca89c0.svg";